import type { ReactNode } from 'react';

/**
 * Pack B layout primitive. On mobile viewports, a fixed bottom bar carrying a
 * form's primary action (and an optional running total). On desktop it renders
 * as a static, right-aligned inline row. Pages using it should pad their bottom
 * so the fixed bar never covers content (e.g. a `pb-24 sm:pb-0` wrapper).
 */
export function StickyActionBar({
  children,
  total
}: {
  children: ReactNode;
  /** Optional running total shown on the left (mono, tabular). */
  total?: ReactNode;
}) {
  return (
    <div
      className={
        'fixed inset-x-0 bottom-0 z-20 border-t border-slate-200 bg-surface/95 ' +
        'backdrop-blur px-4 py-3 shadow-[0_-1px_3px_rgba(0,0,0,0.04)] ' +
        'sm:static sm:inset-auto sm:z-auto sm:border-0 sm:bg-transparent sm:p-0 sm:shadow-none sm:backdrop-blur-none'
      }
    >
      <div className="mx-auto flex max-w-3xl items-center justify-between gap-4 sm:justify-end">
        {total != null && (
          <div className="font-mono text-sm text-ink sm:mr-auto">{total}</div>
        )}
        <div className="flex items-center gap-3">{children}</div>
      </div>
    </div>
  );
}
